import {useEffect} from "react";

export default function RedirectFAQs() {
  useEffect(() => {
    window.location.replace("https://help.alphacapitalgroup.uk/en/");
  }, []);

  return null;
}
